function EducationCard() {
  return (
    <article className="education-card">
      <span className="education-period">2017 — 2020</span>

      <h3 className="education-degree">
        Bachelor's Degree in Computer Engineering
      </h3>

      <p className="education-school">
        School of Technology and Management of Viseu (ESTGV)
      </p>

      <p className="education-description">
        Built a strong foundation in software engineering, algorithms, databases
        and computer systems while participating in industry-focused projects.
      </p>
    </article>
  );
}

export default EducationCard;
